import React from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import MainServices from './pages/services/MainServices';
import B2CServices from './pages/services/B2CServices';
import B2BServices from './pages/services/B2BServices';

const ServicesLayout = () => <Outlet />;

const AppRoutes = () => (
  <Routes>
    <Route path='/' element={<Home />} />
    <Route path='/about' element={<About />} />
    <Route path='/contact' element={<Contact />} />
    <Route path='/services' element={<ServicesLayout />}>
      <Route index element={<MainServices />} />
      <Route path='b2c' element={<B2CServices />} />
      <Route path='b2b' element={<B2BServices />} />
      <Route path='*' element={<Navigate to='/' replace />} />
    </Route>
    <Route path='*' element={<Navigate to='/' replace />} />
  </Routes>
);

export default AppRoutes;
